// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from "./client";
import { client } from "./client.gen";
import type {
  AdminAcceptRoadmapTriageData,
  AdminAcceptRoadmapTriageErrors,
  AdminAcceptRoadmapTriageResponses,
  AdminActivityActionsData,
  AdminActivityActionsResponses,
  AdminActivityAnalyticsData,
  AdminActivityAnalyticsErrors,
  AdminActivityAnalyticsResponses,
  AdminAddRoadmapBlockerData,
  AdminAddRoadmapBlockerErrors,
  AdminAddRoadmapBlockerResponses,
  AdminAddRoadmapCommentData,
  AdminAddRoadmapCommentErrors,
  AdminAddRoadmapCommentResponses,
  AdminCloseRoadmapTriageData,
  AdminCloseRoadmapTriageErrors,
  AdminCloseRoadmapTriageResponses,
  AdminCreateRoadmapItemData,
  AdminCreateRoadmapItemErrors,
  AdminCreateRoadmapItemResponses,
  AdminCreateTeamData,
  AdminCreateTeamErrors,
  AdminCreateTeamResponses,
  AdminDeleteRoadmapBlockerData,
  AdminDeleteRoadmapBlockerErrors,
  AdminDeleteRoadmapBlockerResponses,
  AdminDeleteRoadmapCommentData,
  AdminDeleteRoadmapCommentErrors,
  AdminDeleteRoadmapCommentResponses,
  AdminDeleteRoadmapItemData,
  AdminDeleteRoadmapItemErrors,
  AdminDeleteRoadmapItemResponses,
  AdminDeleteRoadmapTriageData,
  AdminDeleteRoadmapTriageErrors,
  AdminDeleteRoadmapTriageResponses,
  AdminDeleteTeamData,
  AdminDeleteTeamErrors,
  AdminDeleteTeamResponses,
  AdminDeleteUserData,
  AdminDeleteUserErrors,
  AdminDeleteUserResponses,
  AdminFollowRoadmapItemData,
  AdminFollowRoadmapItemErrors,
  AdminFollowRoadmapItemResponses,
  AdminGetRoadmapData,
  AdminGetRoadmapErrors,
  AdminGetRoadmapResponses,
  AdminGetUserData,
  AdminGetUserErrors,
  AdminGetUserResponses,
  AdminListActivityData,
  AdminListActivityErrors,
  AdminListActivityResponses,
  AdminListRoadmapCommentsData,
  AdminListRoadmapCommentsErrors,
  AdminListRoadmapCommentsResponses,
  AdminListTeamsData,
  AdminListTeamsResponses,
  AdminListUsersData,
  AdminListUsersResponses,
  AdminMcpBlockUserData,
  AdminMcpBlockUserErrors,
  AdminMcpBlockUserResponses,
  AdminMcpCallsData,
  AdminMcpCallsErrors,
  AdminMcpCallsResponses,
  AdminMcpIssueActionData,
  AdminMcpIssueActionErrors,
  AdminMcpIssueActionResponses,
  AdminMcpIssueData,
  AdminMcpIssueErrors,
  AdminMcpIssueNoteData,
  AdminMcpIssueNoteErrors,
  AdminMcpIssueNoteResponses,
  AdminMcpIssueResponses,
  AdminMcpIssuesAttentionData,
  AdminMcpIssuesAttentionResponses,
  AdminMcpIssuesData,
  AdminMcpIssuesErrors,
  AdminMcpIssuesResponses,
  AdminMcpSpeedData,
  AdminMcpSpeedErrors,
  AdminMcpSpeedResponses,
  AdminMcpUnblockUserData,
  AdminMcpUnblockUserErrors,
  AdminMcpUnblockUserResponses,
  AdminMcpUsageData,
  AdminMcpUsageErrors,
  AdminMcpUsageResponses,
  AdminMcpUsersData,
  AdminMcpUsersResponses,
  AdminMergeRoadmapTriageData,
  AdminMergeRoadmapTriageErrors,
  AdminMergeRoadmapTriageResponses,
  AdminProposeRoadmapIdeaData,
  AdminProposeRoadmapIdeaErrors,
  AdminProposeRoadmapIdeaResponses,
  AdminResolveRoadmapBlockerData,
  AdminResolveRoadmapBlockerErrors,
  AdminResolveRoadmapBlockerResponses,
  AdminRevokeUserSessionsData,
  AdminRevokeUserSessionsErrors,
  AdminRevokeUserSessionsResponses,
  AdminSetPersonOverridesData,
  AdminSetPersonOverridesErrors,
  AdminSetPersonOverridesResponses,
  AdminSetRoadmapBudgetData,
  AdminSetRoadmapBudgetErrors,
  AdminSetRoadmapBudgetResponses,
  AdminSetRoadmapEffortData,
  AdminSetRoadmapEffortErrors,
  AdminSetRoadmapEffortResponses,
  AdminSetRoadmapStatusData,
  AdminSetRoadmapStatusErrors,
  AdminSetRoadmapStatusResponses,
  AdminSetTeamMembersData,
  AdminSetTeamMembersErrors,
  AdminSetTeamMembersResponses,
  AdminSetToolEnabledData,
  AdminSetToolEnabledErrors,
  AdminSetToolEnabledResponses,
  AdminUpdateRoadmapItemData,
  AdminUpdateRoadmapItemErrors,
  AdminUpdateRoadmapItemResponses,
  AdminUpdateTeamData,
  AdminUpdateTeamErrors,
  AdminUpdateTeamResponses,
  AdminUpdateUserData,
  AdminUpdateUserErrors,
  AdminUpdateUserResponses,
  FinishMicrosoftSignInData,
  FinishMicrosoftSignInErrors,
  GetActivityData,
  GetActivityResponses,
  GetBezettingJobData,
  GetBezettingJobErrors,
  GetBezettingJobResponses,
  GetBezettingSectionData,
  GetBezettingSectionErrors,
  GetBezettingSectionResponses,
  GetBezettingSnapshotData,
  GetBezettingSnapshotErrors,
  GetBezettingSnapshotResponses,
  GetConnectorOverviewData,
  GetConnectorOverviewResponses,
  GetHealthData,
  GetHealthResponses,
  GetMaandrapportDetailData,
  GetMaandrapportDetailErrors,
  GetMaandrapportDetailResponses,
  GetMaandrapportJobData,
  GetMaandrapportJobErrors,
  GetMaandrapportJobResponses,
  GetMaandrapportSectionData,
  GetMaandrapportSectionErrors,
  GetMaandrapportSectionResponses,
  GetMaandrapportSnapshotData,
  GetMaandrapportSnapshotErrors,
  GetMaandrapportSnapshotResponses,
  GetMaandrapportViewData,
  GetMaandrapportViewErrors,
  GetMaandrapportViewResponses,
  GetMeData,
  GetMeDetailData,
  GetMeDetailErrors,
  GetMeDetailResponses,
  GetMeResponses,
  GetToolDefinitionData,
  GetToolDefinitionErrors,
  GetToolDefinitionResponses,
  ListAppsData,
  ListAppsErrors,
  ListAppsResponses,
  ListBezettingMeldingenData,
  ListBezettingMeldingenErrors,
  ListBezettingMeldingenResponses,
  LogoutData,
  LogoutResponses,
  MarkBezettingMeldingenReadData,
  MarkBezettingMeldingenReadErrors,
  MarkBezettingMeldingenReadResponses,
  MarkBezettingMeldingenUnreadData,
  MarkBezettingMeldingenUnreadErrors,
  MarkBezettingMeldingenUnreadResponses,
  RecomputeBezettingData,
  RecomputeBezettingErrors,
  RecomputeBezettingResponses,
  RecomputeMaandrapportData,
  RecomputeMaandrapportErrors,
  RecomputeMaandrapportResponses,
  SetPersonalToolEnabledData,
  SetPersonalToolEnabledErrors,
  SetPersonalToolEnabledResponses,
  StartMicrosoftSignInData,
  StartViewAsData,
  StartViewAsErrors,
  StartViewAsResponses,
  StopViewAsData,
  StopViewAsResponses,
  UpdateProfileData,
  UpdateProfileErrors,
  UpdateProfileResponses,
  ViewAsOptionsData,
  ViewAsOptionsErrors,
  ViewAsOptionsResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * List Apps
 *
 * The apps the caller may open, in the dashboard's order, and the dashboard's admins.
 *
 * An app opens for whoever holds its unit (from a team or an exception, never the
 * default team) and every data unit it requires. Each app's `unread` counts its open
 * unread meldingen per subject; it is null when they cannot be counted, which never
 * fails the list. `contacts` are the admins, who grant access, by name.
 */
export const listApps = <ThrowOnError extends boolean = false>(
  options?: Options<ListAppsData, ThrowOnError>,
): RequestResult<ListAppsResponses, ListAppsErrors, ThrowOnError> =>
  (options?.client ?? client).get<ListAppsResponses, ListAppsErrors, ThrowOnError>({
    url: "/apps",
    ...options,
  });

/**
 * Get Bezetting Snapshot
 *
 * The latest complete snapshot, its recompute and whether a new one can start.
 *
 * `snapshot` is null before the first recompute. `job` is the running recompute, else
 * the latest one when it failed after that snapshot. `recompute` says whether one can
 * start now: not while one runs, not within 10 minutes of the last start, and not
 * while Odoo is not configured.
 */
export const getBezettingSnapshot = <ThrowOnError extends boolean = false>(
  options?: Options<GetBezettingSnapshotData, ThrowOnError>,
): RequestResult<GetBezettingSnapshotResponses, GetBezettingSnapshotErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    GetBezettingSnapshotResponses,
    GetBezettingSnapshotErrors,
    ThrowOnError
  >({ url: "/apps/bezetting/snapshot", ...options });

/**
 * Get Bezetting Section
 *
 * One section of a complete snapshot, as the recompute stored it.
 *
 * Its tables are compact (`{cols, rows}`), its dates ISO and its shares fractions; it
 * names its own key in `section`. Never cached by the browser: it holds client names.
 */
export const getBezettingSection = <ThrowOnError extends boolean = false>(
  options: Options<GetBezettingSectionData, ThrowOnError>,
): RequestResult<GetBezettingSectionResponses, GetBezettingSectionErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetBezettingSectionResponses,
    GetBezettingSectionErrors,
    ThrowOnError
  >({ url: "/apps/bezetting/snapshots/{snapshot_id}/sections/{key}", ...options });

/**
 * Recompute Bezetting
 *
 * Start a recompute of the snapshot from Odoo, in the background.
 *
 * Answers at once with the job (202); poll `GET /apps/bezetting/jobs/{job_id}` until
 * it is complete or failed. One runs at a time (409), at most one starts every 10
 * minutes, counted from the last start (429 with `Retry-After`).
 */
export const recomputeBezetting = <ThrowOnError extends boolean = false>(
  options?: Options<RecomputeBezettingData, ThrowOnError>,
): RequestResult<RecomputeBezettingResponses, RecomputeBezettingErrors, ThrowOnError> =>
  (options?.client ?? client).post<
    RecomputeBezettingResponses,
    RecomputeBezettingErrors,
    ThrowOnError
  >({ url: "/apps/bezetting/recompute", ...options });

/**
 * Get Bezetting Job
 *
 * One recompute: running, complete or failed (with its error kind).
 *
 * Polled while a recompute runs, so only a refusal goes into the read log.
 */
export const getBezettingJob = <ThrowOnError extends boolean = false>(
  options: Options<GetBezettingJobData, ThrowOnError>,
): RequestResult<GetBezettingJobResponses, GetBezettingJobErrors, ThrowOnError> =>
  (options.client ?? client).get<GetBezettingJobResponses, GetBezettingJobErrors, ThrowOnError>({
    url: "/apps/bezetting/jobs/{job_id}",
    ...options,
  });

/**
 * List Bezetting Meldingen
 *
 * The open meldingen that are unread or read today (in Belgium), in the snapshot's order.
 *
 * The read state is shared: one person's "Gelezen" reads a melding for everyone.
 */
export const listBezettingMeldingen = <ThrowOnError extends boolean = false>(
  options?: Options<ListBezettingMeldingenData, ThrowOnError>,
): RequestResult<ListBezettingMeldingenResponses, ListBezettingMeldingenErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    ListBezettingMeldingenResponses,
    ListBezettingMeldingenErrors,
    ThrowOnError
  >({ url: "/apps/bezetting/meldingen", ...options });

/**
 * Mark Bezetting Meldingen Read
 *
 * Mark meldingen read for everyone; returns the list as `GET` does, plus `ignored`.
 *
 * Idempotent: a key read already stays read. Unknown and resolved keys are left
 * alone and named in `ignored`.
 */
export const markBezettingMeldingenRead = <ThrowOnError extends boolean = false>(
  options: Options<MarkBezettingMeldingenReadData, ThrowOnError>,
): RequestResult<
  MarkBezettingMeldingenReadResponses,
  MarkBezettingMeldingenReadErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    MarkBezettingMeldingenReadResponses,
    MarkBezettingMeldingenReadErrors,
    ThrowOnError
  >({
    url: "/apps/bezetting/meldingen/read",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Mark Bezetting Meldingen Unread
 *
 * Undo today's reads; returns the list as `GET` does, plus `ignored`.
 *
 * Only a read of today (in Belgium) can be undone: unknown and resolved keys, and
 * keys not read today, are left alone and named in `ignored`.
 */
export const markBezettingMeldingenUnread = <ThrowOnError extends boolean = false>(
  options: Options<MarkBezettingMeldingenUnreadData, ThrowOnError>,
): RequestResult<
  MarkBezettingMeldingenUnreadResponses,
  MarkBezettingMeldingenUnreadErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    MarkBezettingMeldingenUnreadResponses,
    MarkBezettingMeldingenUnreadErrors,
    ThrowOnError
  >({
    url: "/apps/bezetting/meldingen/unread",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Maandrapport Snapshot
 *
 * The latest complete snapshot, its recompute and whether a new one can start.
 *
 * `snapshot` is null before the first recompute. `job` is the running recompute, else
 * the latest one when it failed after that snapshot. `recompute` says whether one can
 * start now: not while one runs, not within 10 minutes of the last start, and not
 * while Odoo is not configured.
 */
export const getMaandrapportSnapshot = <ThrowOnError extends boolean = false>(
  options?: Options<GetMaandrapportSnapshotData, ThrowOnError>,
): RequestResult<GetMaandrapportSnapshotResponses, GetMaandrapportSnapshotErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    GetMaandrapportSnapshotResponses,
    GetMaandrapportSnapshotErrors,
    ThrowOnError
  >({ url: "/apps/maandrapport/snapshot", ...options });

/**
 * Get Maandrapport Section
 *
 * One section of a complete snapshot, as the recompute stored it.
 *
 * Its long lists are compact tables (`{cols, rows}`), its amounts whole euros excl.
 * VAT, its dates ISO and its shares fractions; it names its own key in `section`.
 * Never cached by the browser: it holds client names.
 */
export const getMaandrapportSection = <ThrowOnError extends boolean = false>(
  options: Options<GetMaandrapportSectionData, ThrowOnError>,
): RequestResult<GetMaandrapportSectionResponses, GetMaandrapportSectionErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetMaandrapportSectionResponses,
    GetMaandrapportSectionErrors,
    ThrowOnError
  >({ url: "/apps/maandrapport/snapshots/{snapshot_id}/sections/{key}", ...options });

/**
 * Get Maandrapport View
 *
 * Every chapter of one range against its comparison, from the snapshot's facts.
 *
 * The range is `from` to `to`, both included; without either, the snapshot's default
 * (`meta.default_range`). Its comparison is the same range a year earlier, or for
 * whole calendar months the same months a year earlier. Amounts are whole euros excl.
 * VAT, ratios four decimals. Never cached by the browser: it holds client names.
 */
export const getMaandrapportView = <ThrowOnError extends boolean = false>(
  options: Options<GetMaandrapportViewData, ThrowOnError>,
): RequestResult<GetMaandrapportViewResponses, GetMaandrapportViewErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetMaandrapportViewResponses,
    GetMaandrapportViewErrors,
    ThrowOnError
  >({ url: "/apps/maandrapport/snapshots/{snapshot_id}/view", ...options });

/**
 * Get Maandrapport Detail
 *
 * The breakdown of one figure of a range, from the snapshot's facts.
 *
 * `kind` is one of `activity`, `region`, `ageing`, `due_month`, `concentration`,
 * `rentals`, `transports`, `unbilled`, `returning`, `new_clients`, `clients`,
 * `due_invoices`, `invoice` and `client`, and `key` says which: an activity, a region,
 * an age band (or `overdue`, or `open`), a due month `YYYY-MM`, an activity (or
 * `alles`), a crane type, a class (`BK`, `TK`), a finding (or `<finding>:<class>`, or
 * `alle:<class>` for a class over every finding), `away` or `back`, `new`, none (for
 * `clients`, every client of the range, and `due_invoices`, every invoice due in it),
 * a document's id, or a partner id, ids in ASCII digits. The range is as for the view;
 * `due_month`, `unbilled` and `invoice` are the state on the snapshot day whatever the
 * range. Each carries its kind, key and range, and the names of the clients it lists
 * (never empty); its totals are summed before rounding; invoices, orders and a client
 * link to Odoo (`odoo_url`) when the backend knows its host. Never cached by the
 * browser: it holds client names.
 */
export const getMaandrapportDetail = <ThrowOnError extends boolean = false>(
  options: Options<GetMaandrapportDetailData, ThrowOnError>,
): RequestResult<GetMaandrapportDetailResponses, GetMaandrapportDetailErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetMaandrapportDetailResponses,
    GetMaandrapportDetailErrors,
    ThrowOnError
  >({ url: "/apps/maandrapport/snapshots/{snapshot_id}/detail/{kind}", ...options });

/**
 * Recompute Maandrapport
 *
 * Start a recompute of the snapshot from Odoo, in the background.
 *
 * Answers at once with the job (202); poll `GET /apps/maandrapport/jobs/{job_id}` until
 * it is complete or failed. One runs at a time (409), at most one starts every 10
 * minutes, counted from the last start (429 with `Retry-After`).
 */
export const recomputeMaandrapport = <ThrowOnError extends boolean = false>(
  options?: Options<RecomputeMaandrapportData, ThrowOnError>,
): RequestResult<RecomputeMaandrapportResponses, RecomputeMaandrapportErrors, ThrowOnError> =>
  (options?.client ?? client).post<
    RecomputeMaandrapportResponses,
    RecomputeMaandrapportErrors,
    ThrowOnError
  >({ url: "/apps/maandrapport/recompute", ...options });

/**
 * Get Maandrapport Job
 *
 * One recompute: running, complete or failed (with its error kind).
 *
 * Polled while a recompute runs, so only a refusal goes into the read log.
 */
export const getMaandrapportJob = <ThrowOnError extends boolean = false>(
  options: Options<GetMaandrapportJobData, ThrowOnError>,
): RequestResult<GetMaandrapportJobResponses, GetMaandrapportJobErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetMaandrapportJobResponses,
    GetMaandrapportJobErrors,
    ThrowOnError
  >({ url: "/apps/maandrapport/jobs/{job_id}", ...options });

/**
 * Admin Get Roadmap
 *
 * Every roadmap item in rank order, a month's figures, the people to name and, for a
 * developer, the open triage.
 *
 * For admins, owners and developers. `month` picks the month of the figures (the
 * current month in Belgium by default). Open work planned in a month that has passed
 * shows, and counts, in the current month; done work in the month it was finished in.
 * Only a developer's items carry `developer`, only an owner's and a developer's items
 * and month carry hours (the effort, actual and used hours, the month's figures, its
 * budget and what is left; an admin's month shows its items' shares alone), and only a
 * developer's overview carries `triage`, the ideas and questions waiting for review.
 */
export const adminGetRoadmap = <ThrowOnError extends boolean = false>(
  options?: Options<AdminGetRoadmapData, ThrowOnError>,
): RequestResult<AdminGetRoadmapResponses, AdminGetRoadmapErrors, ThrowOnError> =>
  (options?.client ?? client).get<AdminGetRoadmapResponses, AdminGetRoadmapErrors, ThrowOnError>({
    url: "/admin/roadmap",
    ...options,
  });

/**
 * Admin Create Roadmap Item
 *
 * Add an idea straight to the roadmap (developers): no month, and its creator follows
 * it.
 *
 * It carries its Linear ids (at least one) and, when given, its effort. `language` names
 * the language its title and summary are written in (Dutch unless given); an unknown
 * one is a 422. Anyone else proposes an idea to the triage instead (`/triage`).
 */
export const adminCreateRoadmapItem = <ThrowOnError extends boolean = false>(
  options: Options<AdminCreateRoadmapItemData, ThrowOnError>,
): RequestResult<AdminCreateRoadmapItemResponses, AdminCreateRoadmapItemErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminCreateRoadmapItemResponses,
    AdminCreateRoadmapItemErrors,
    ThrowOnError
  >({
    url: "/admin/roadmap/items",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Delete Roadmap Item
 *
 * Delete an item: DC an idea or a planned item, a developer any item not done.
 *
 * Its followers, its blockages and the blockages naming it go with it. A done item
 * stays.
 */
export const adminDeleteRoadmapItem = <ThrowOnError extends boolean = false>(
  options: Options<AdminDeleteRoadmapItemData, ThrowOnError>,
): RequestResult<AdminDeleteRoadmapItemResponses, AdminDeleteRoadmapItemErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    AdminDeleteRoadmapItemResponses,
    AdminDeleteRoadmapItemErrors,
    ThrowOnError
  >({ url: "/admin/roadmap/items/{item_id}", ...options });

/**
 * Admin Update Roadmap Item
 *
 * Change any of an item's title, summary, priority and deadline.
 *
 * A field left out stays. DC changes the title, summary and deadline of an idea or a
 * planned item, a developer of any item not done; the priority changes until the item
 * is done. What an item waits on changes through its blockages (`/blockers`).
 */
export const adminUpdateRoadmapItem = <ThrowOnError extends boolean = false>(
  options: Options<AdminUpdateRoadmapItemData, ThrowOnError>,
): RequestResult<AdminUpdateRoadmapItemResponses, AdminUpdateRoadmapItemErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    AdminUpdateRoadmapItemResponses,
    AdminUpdateRoadmapItemErrors,
    ThrowOnError
  >({
    url: "/admin/roadmap/items/{item_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Set Roadmap Status
 *
 * Move an item to another status.
 *
 * idea to planned (needs an effort; the month given, else the current one in
 * Belgium, which DC gives as the current month or a later one) and planned back to
 * idea (clears the month) for DC and developers; planned to in progress, back to
 * planned, and in progress to done (with optional actual hours) for developers only. A
 * done item moves to the month it was finished in, the current one in Belgium, so its
 * hours count there. Any other change is refused: done is final.
 */
export const adminSetRoadmapStatus = <ThrowOnError extends boolean = false>(
  options: Options<AdminSetRoadmapStatusData, ThrowOnError>,
): RequestResult<AdminSetRoadmapStatusResponses, AdminSetRoadmapStatusErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminSetRoadmapStatusResponses,
    AdminSetRoadmapStatusErrors,
    ThrowOnError
  >({
    url: "/admin/roadmap/items/{item_id}/status",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Set Roadmap Effort
 *
 * Set any of an item's effort, actual hours, month and Linear ids (developers).
 *
 * A field left out stays. The effort is one of the steps De Ceuster sees (2, 4 or 8
 * hours, then multiples of 4), never a raw estimate: that stays in Linear. The effort
 * and the Linear ids change on an item not done, the actual hours on a done item (null:
 * the effort counts), the month on any item but an idea. `linear_ids` replaces the
 * item's ids.
 */
export const adminSetRoadmapEffort = <ThrowOnError extends boolean = false>(
  options: Options<AdminSetRoadmapEffortData, ThrowOnError>,
): RequestResult<AdminSetRoadmapEffortResponses, AdminSetRoadmapEffortErrors, ThrowOnError> =>
  (options.client ?? client).put<
    AdminSetRoadmapEffortResponses,
    AdminSetRoadmapEffortErrors,
    ThrowOnError
  >({
    url: "/admin/roadmap/items/{item_id}/developer",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Follow Roadmap Item
 *
 * Follow an item, or stop following it, until it is done. Not logged.
 *
 * A done item keeps its followers: following or unfollowing it is refused.
 */
export const adminFollowRoadmapItem = <ThrowOnError extends boolean = false>(
  options: Options<AdminFollowRoadmapItemData, ThrowOnError>,
): RequestResult<AdminFollowRoadmapItemResponses, AdminFollowRoadmapItemErrors, ThrowOnError> =>
  (options.client ?? client).put<
    AdminFollowRoadmapItemResponses,
    AdminFollowRoadmapItemErrors,
    ThrowOnError
  >({
    url: "/admin/roadmap/items/{item_id}/following",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Add Roadmap Blocker
 *
 * Add a blockage to an item: people, another item or an outside party; answers the item.
 *
 * Exactly one of `people`, `item_id` and `party`, with an `ask` saying what they need
 * to do (optional for an item). DC and developers add blockages to any item not done.
 * The people need a dashboard account; the item waited on must exist and must not, through
 * its open blockages, wait on this item.
 */
export const adminAddRoadmapBlocker = <ThrowOnError extends boolean = false>(
  options: Options<AdminAddRoadmapBlockerData, ThrowOnError>,
): RequestResult<AdminAddRoadmapBlockerResponses, AdminAddRoadmapBlockerErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminAddRoadmapBlockerResponses,
    AdminAddRoadmapBlockerErrors,
    ThrowOnError
  >({
    url: "/admin/roadmap/items/{item_id}/blockers",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Resolve Roadmap Blocker
 *
 * Resolve a blockage of an item not done; answers the item.
 *
 * DC and developers resolve any blockage of an item not done, one that names them
 * included. A member a blockage names never reaches the roadmap: DC or a developer
 * resolves it for them. One resolved already (by someone, or because the item it names
 * is done) stays as it is: the answer is the item, unchanged, and nothing is logged.
 */
export const adminResolveRoadmapBlocker = <ThrowOnError extends boolean = false>(
  options: Options<AdminResolveRoadmapBlockerData, ThrowOnError>,
): RequestResult<
  AdminResolveRoadmapBlockerResponses,
  AdminResolveRoadmapBlockerErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AdminResolveRoadmapBlockerResponses,
    AdminResolveRoadmapBlockerErrors,
    ThrowOnError
  >({ url: "/admin/roadmap/items/{item_id}/blockers/{blocker_id}/resolve", ...options });

/**
 * Admin Delete Roadmap Blocker
 *
 * Remove a blockage added by mistake, open or resolved; answers the item.
 *
 * DC and developers, on any item not done.
 */
export const adminDeleteRoadmapBlocker = <ThrowOnError extends boolean = false>(
  options: Options<AdminDeleteRoadmapBlockerData, ThrowOnError>,
): RequestResult<
  AdminDeleteRoadmapBlockerResponses,
  AdminDeleteRoadmapBlockerErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    AdminDeleteRoadmapBlockerResponses,
    AdminDeleteRoadmapBlockerErrors,
    ThrowOnError
  >({ url: "/admin/roadmap/items/{item_id}/blockers/{blocker_id}", ...options });

/**
 * Admin Set Roadmap Budget
 *
 * Set a month's budget in whole hours; answers the month's figures.
 *
 * A developer sets any month's, an owner the current month's (in Belgium) and later
 * ones'; an admin none. A change is logged with the budget before and after, which
 * the admins' activity feeds show an admin with the month alone (`activity`).
 */
export const adminSetRoadmapBudget = <ThrowOnError extends boolean = false>(
  options: Options<AdminSetRoadmapBudgetData, ThrowOnError>,
): RequestResult<AdminSetRoadmapBudgetResponses, AdminSetRoadmapBudgetErrors, ThrowOnError> =>
  (options.client ?? client).put<
    AdminSetRoadmapBudgetResponses,
    AdminSetRoadmapBudgetErrors,
    ThrowOnError
  >({
    url: "/admin/roadmap/months/{month}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin List Roadmap Comments
 *
 * An item's comments, oldest first, each saying whether the viewer may delete it.
 */
export const adminListRoadmapComments = <ThrowOnError extends boolean = false>(
  options: Options<AdminListRoadmapCommentsData, ThrowOnError>,
): RequestResult<AdminListRoadmapCommentsResponses, AdminListRoadmapCommentsErrors, ThrowOnError> =>
  (options.client ?? client).get<
    AdminListRoadmapCommentsResponses,
    AdminListRoadmapCommentsErrors,
    ThrowOnError
  >({ url: "/admin/roadmap/items/{item_id}/comments", ...options });

/**
 * Admin Add Roadmap Comment
 *
 * Comment on an item not done, mentioning people who reach the roadmap.
 *
 * Anyone who reaches the roadmap comments. A mention names a dashboard account whose
 * role is admin, owner or developer; no notification goes out yet. Logged with the
 * item's title, never the comment.
 */
export const adminAddRoadmapComment = <ThrowOnError extends boolean = false>(
  options: Options<AdminAddRoadmapCommentData, ThrowOnError>,
): RequestResult<AdminAddRoadmapCommentResponses, AdminAddRoadmapCommentErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminAddRoadmapCommentResponses,
    AdminAddRoadmapCommentErrors,
    ThrowOnError
  >({
    url: "/admin/roadmap/items/{item_id}/comments",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Delete Roadmap Comment
 *
 * Delete a comment: its author, or a developer, on any item (a done one too).
 *
 * Logged with the item's title, never the comment.
 */
export const adminDeleteRoadmapComment = <ThrowOnError extends boolean = false>(
  options: Options<AdminDeleteRoadmapCommentData, ThrowOnError>,
): RequestResult<
  AdminDeleteRoadmapCommentResponses,
  AdminDeleteRoadmapCommentErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    AdminDeleteRoadmapCommentResponses,
    AdminDeleteRoadmapCommentErrors,
    ThrowOnError
  >({ url: "/admin/roadmap/items/{item_id}/comments/{comment_id}", ...options });

/**
 * Admin Propose Roadmap Idea
 *
 * Pass an idea on to the triage, where a developer reviews it.
 *
 * For admins, owners and developers. `language` names the language its title and
 * summary are written in (Dutch unless given), which the idea keeps once accepted. The
 * same person proposing the same title again, while their earlier one is open and at
 * most 7 days old, adds nothing; the answer is the same, and never the entry, which only
 * a developer sees. Logged without the idea.
 */
export const adminProposeRoadmapIdea = <ThrowOnError extends boolean = false>(
  options: Options<AdminProposeRoadmapIdeaData, ThrowOnError>,
): RequestResult<AdminProposeRoadmapIdeaResponses, AdminProposeRoadmapIdeaErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminProposeRoadmapIdeaResponses,
    AdminProposeRoadmapIdeaErrors,
    ThrowOnError
  >({
    url: "/admin/roadmap/triage",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Accept Roadmap Triage
 *
 * Accept an open triage entry onto the roadmap (developers); answers the new idea.
 *
 * In one transaction: the idea, as `adminCreateRoadmapItem` adds one (its Linear ids, an
 * optional effort, no month, its creator following it) with the title and summary
 * given, and the entry marked accepted with the idea's id. The idea is in the language
 * given, else an idea entry's own, else Dutch (a question's language never tags the
 * developer's texts). Whoever submitted an idea follows it too when
 * their dashboard account is an admin, an owner or a developer; whoever asked a question
 * never does. Logged with the title given, never the question or the idea's body.
 */
export const adminAcceptRoadmapTriage = <ThrowOnError extends boolean = false>(
  options: Options<AdminAcceptRoadmapTriageData, ThrowOnError>,
): RequestResult<AdminAcceptRoadmapTriageResponses, AdminAcceptRoadmapTriageErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminAcceptRoadmapTriageResponses,
    AdminAcceptRoadmapTriageErrors,
    ThrowOnError
  >({
    url: "/admin/roadmap/triage/{entry_id}/accept",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Close Roadmap Triage
 *
 * Close an open triage entry, with an optional note (developers), which whoever
 * submitted the entry reads only when the body says the closer saw that (`share_note`).
 *
 * Logged without what was submitted, and without the note.
 */
export const adminCloseRoadmapTriage = <ThrowOnError extends boolean = false>(
  options: Options<AdminCloseRoadmapTriageData, ThrowOnError>,
): RequestResult<AdminCloseRoadmapTriageResponses, AdminCloseRoadmapTriageErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminCloseRoadmapTriageResponses,
    AdminCloseRoadmapTriageErrors,
    ThrowOnError
  >({
    url: "/admin/roadmap/triage/{entry_id}/close",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Merge Roadmap Triage
 *
 * Merge an open triage entry into an item on the roadmap that is not done
 * (developers); answers that item.
 *
 * The entry is marked accepted with the item, as an acceptance would mark it with a new
 * idea, and whoever submitted an idea follows the item when their dashboard account is
 * an admin, an owner or a developer; whoever asked a question never does. Logged with
 * the item's title, under the acceptance's action, never with what was submitted.
 */
export const adminMergeRoadmapTriage = <ThrowOnError extends boolean = false>(
  options: Options<AdminMergeRoadmapTriageData, ThrowOnError>,
): RequestResult<AdminMergeRoadmapTriageResponses, AdminMergeRoadmapTriageErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminMergeRoadmapTriageResponses,
    AdminMergeRoadmapTriageErrors,
    ThrowOnError
  >({
    url: "/admin/roadmap/triage/{entry_id}/merge",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Delete Roadmap Triage
 *
 * Delete an open triage entry for good (developers).
 *
 * One accepted or closed meanwhile is refused and stays, as a close or a merge of it
 * would be, so the link between what someone submitted and the item it became is never
 * lost from a stale page. Logged under the close action, without what was submitted.
 */
export const adminDeleteRoadmapTriage = <ThrowOnError extends boolean = false>(
  options: Options<AdminDeleteRoadmapTriageData, ThrowOnError>,
): RequestResult<AdminDeleteRoadmapTriageResponses, AdminDeleteRoadmapTriageErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    AdminDeleteRoadmapTriageResponses,
    AdminDeleteRoadmapTriageErrors,
    ThrowOnError
  >({ url: "/admin/roadmap/triage/{entry_id}", ...options });

/**
 * Health
 *
 * Return a simple health status payload.
 */
export const getHealth = <ThrowOnError extends boolean = false>(
  options?: Options<GetHealthData, ThrowOnError>,
): RequestResult<GetHealthResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetHealthResponses, unknown, ThrowOnError>({
    url: "/health",
    ...options,
  });

/**
 * Auth Microsoft Start
 *
 * Start a Microsoft sign-in, the only way into the dashboard.
 *
 * Public. Keeps a fresh PKCE verifier in a 10-minute cookie for the callback
 * and redirects to Supabase's Azure sign-in with its S256 challenge. Without
 * FRONTEND_URL there is no callback to return to: a 303 to
 * ``/login?error=microsoft_failed`` instead, without a cookie.
 */
export const startMicrosoftSignIn = <ThrowOnError extends boolean = false>(
  options?: Options<StartMicrosoftSignInData, ThrowOnError>,
): RequestResult<unknown, unknown, ThrowOnError> =>
  (options?.client ?? client).get<unknown, unknown, ThrowOnError>({
    url: "/auth/microsoft/start",
    ...options,
  });

/**
 * Auth Microsoft Callback
 *
 * Finish a Microsoft sign-in: where Supabase sends the browser back.
 *
 * Public. Exchanges the code with the PKCE cookie's verifier and checks the
 * account: an email Supabase verified with Microsoft's xms_edov claim true, the
 * one its Microsoft identity carries, in an allowed domain, with a profile of a
 * known role. The first account to finish a sign-in is made admin first, so its
 * session starts as admin. Always a 303 to a path of this app, never an absolute URL:
 * ``/home`` with a new session, or
 * ``/login?error=<code>`` without one (microsoft_cancelled, microsoft_failed,
 * email_not_verified, domain_not_allowed, no_account). Always clears the PKCE
 * cookie.
 */
export const finishMicrosoftSignIn = <ThrowOnError extends boolean = false>(
  options?: Options<FinishMicrosoftSignInData, ThrowOnError>,
): RequestResult<unknown, FinishMicrosoftSignInErrors, ThrowOnError> =>
  (options?.client ?? client).get<unknown, FinishMicrosoftSignInErrors, ThrowOnError>({
    url: "/auth/microsoft/callback",
    ...options,
  });

/**
 * Auth Logout
 *
 * Sign out — clear the session cookie, and a view as someone else with it.
 *
 * Signing out never fails: without a valid session it only clears the cookies. When a
 * view of this session was on, it ends with `view_as_stop` in the signed-in person's
 * own activity log, as stopping it does (best effort).
 */
export const logout = <ThrowOnError extends boolean = false>(
  options?: Options<LogoutData, ThrowOnError>,
): RequestResult<LogoutResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<LogoutResponses, unknown, ThrowOnError>({
    url: "/auth/logout",
    ...options,
  });

/**
 * Auth Me
 *
 * Get the current user's profile.
 *
 * `dev_bypass` is present, true, only while the local dev auth bypass is on, all three
 * of its settings checked again now (`dev_bypass_active`): the dashboard then offers
 * the persona switch. While a developer views the dashboard as someone else, the
 * viewed person's profile, or a role view's (no id, the made-up email
 * `<role>@bekijken-als.invalid`, no names, the role), with `view_as`.
 */
export const getMe = <ThrowOnError extends boolean = false>(
  options?: Options<GetMeData, ThrowOnError>,
): RequestResult<GetMeResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetMeResponses, unknown, ThrowOnError>({
    url: "/auth/me",
    ...options,
  });

/**
 * Auth Me Detail
 *
 * Get the current user's profile with timeline fields.
 *
 * While a developer views the dashboard as a person, theirs; a view as a role has no
 * account, so 404 `user_not_found`.
 */
export const getMeDetail = <ThrowOnError extends boolean = false>(
  options?: Options<GetMeDetailData, ThrowOnError>,
): RequestResult<GetMeDetailResponses, GetMeDetailErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetMeDetailResponses, GetMeDetailErrors, ThrowOnError>({
    url: "/auth/me/detail",
    ...options,
  });

/**
 * Auth Update Profile
 *
 * Update current user's name.
 */
export const updateProfile = <ThrowOnError extends boolean = false>(
  options: Options<UpdateProfileData, ThrowOnError>,
): RequestResult<UpdateProfileResponses, UpdateProfileErrors, ThrowOnError> =>
  (options.client ?? client).put<UpdateProfileResponses, UpdateProfileErrors, ThrowOnError>({
    url: "/auth/profile",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Auth Activity
 *
 * Get the current user's activity log.
 *
 * While a developer views the dashboard as a person, theirs; a view as a role has no
 * account and no activity.
 */
export const getActivity = <ThrowOnError extends boolean = false>(
  options?: Options<GetActivityData, ThrowOnError>,
): RequestResult<GetActivityResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetActivityResponses, unknown, ThrowOnError>({
    url: "/auth/activity",
    ...options,
  });

/**
 * View As Options
 *
 * Whom the developer may view the dashboard as (developer only, also during a view).
 *
 * Everyone with a dashboard account but the developer themselves, by name, each with
 * their role now, the names of their teams (the Admins team by their role included)
 * and their latest connector call while it is still recorded; and the roles Lid,
 * Beheerder and Eigenaar.
 */
export const viewAsOptions = <ThrowOnError extends boolean = false>(
  options?: Options<ViewAsOptionsData, ThrowOnError>,
): RequestResult<ViewAsOptionsResponses, ViewAsOptionsErrors, ThrowOnError> =>
  (options?.client ?? client).get<ViewAsOptionsResponses, ViewAsOptionsErrors, ThrowOnError>({
    url: "/auth/view-as/options",
    ...options,
  });

/**
 * Stop View As
 *
 * Stop viewing the dashboard as someone else (anyone signed in). Idempotent.
 *
 * Deletes the view-as cookie. When a view of this session was on, logs `view_as_stop`
 * in the signed-in person's own activity log, naming the person's email or the role.
 */
export const stopViewAs = <ThrowOnError extends boolean = false>(
  options?: Options<StopViewAsData, ThrowOnError>,
): RequestResult<StopViewAsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).delete<StopViewAsResponses, unknown, ThrowOnError>({
    url: "/auth/view-as",
    ...options,
  });

/**
 * Start View As
 *
 * View the dashboard as one person or as a role, read-only (developer only).
 *
 * Starting while a view is on switches it. Sets the view-as cookie (`auth.view_as`),
 * bound to this session, for 12 hours at most, and logs `view_as_start` or
 * `view_as_switch` in the developer's own activity log, naming the person's email or
 * the role. From the next request the dashboard answers as the viewed identity and
 * refuses every change (403 `view_as_read_only`).
 */
export const startViewAs = <ThrowOnError extends boolean = false>(
  options: Options<StartViewAsData, ThrowOnError>,
): RequestResult<StartViewAsResponses, StartViewAsErrors, ThrowOnError> =>
  (options.client ?? client).post<StartViewAsResponses, StartViewAsErrors, ThrowOnError>({
    url: "/auth/view-as",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin List Users
 *
 * List all users (admin only).
 */
export const adminListUsers = <ThrowOnError extends boolean = false>(
  options?: Options<AdminListUsersData, ThrowOnError>,
): RequestResult<AdminListUsersResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<AdminListUsersResponses, unknown, ThrowOnError>({
    url: "/admin/users",
    ...options,
  });

/**
 * Admin Delete User
 *
 * Delete a user (admin or higher). Self-deletion blocked.
 *
 * Only a developer deletes a developer's account, and only an owner or a
 * developer an owner's.
 */
export const adminDeleteUser = <ThrowOnError extends boolean = false>(
  options: Options<AdminDeleteUserData, ThrowOnError>,
): RequestResult<AdminDeleteUserResponses, AdminDeleteUserErrors, ThrowOnError> =>
  (options.client ?? client).delete<AdminDeleteUserResponses, AdminDeleteUserErrors, ThrowOnError>({
    url: "/admin/users/{user_id}",
    ...options,
  });

/**
 * Admin Get User
 *
 * Get a single user detail with activity logs (admin only).
 *
 * A roadmap budget change in the log names the month alone for a viewer who does not
 * see the budget (an admin).
 */
export const adminGetUser = <ThrowOnError extends boolean = false>(
  options: Options<AdminGetUserData, ThrowOnError>,
): RequestResult<AdminGetUserResponses, AdminGetUserErrors, ThrowOnError> =>
  (options.client ?? client).get<AdminGetUserResponses, AdminGetUserErrors, ThrowOnError>({
    url: "/admin/users/{user_id}",
    ...options,
  });

/**
 * Admin Update User
 *
 * Update a user's name or role (admin or higher).
 *
 * Nobody changes their own role. Only a developer gives the developer role or
 * edits a developer's account, only an owner or a developer gives the owner role
 * or edits an owner's account, and any admin or higher gives the admin and user
 * roles to an admin or a user. The caller's role is the one AdminDep just read
 * from the database.
 */
export const adminUpdateUser = <ThrowOnError extends boolean = false>(
  options: Options<AdminUpdateUserData, ThrowOnError>,
): RequestResult<AdminUpdateUserResponses, AdminUpdateUserErrors, ThrowOnError> =>
  (options.client ?? client).put<AdminUpdateUserResponses, AdminUpdateUserErrors, ThrowOnError>({
    url: "/admin/users/{user_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Revoke User Sessions
 *
 * Sign a user out everywhere: every session cookie stops working (admin or higher).
 *
 * Not for your own account. The same rule as changing an account: only a
 * developer signs a developer out, and only an owner or a developer an owner.
 */
export const adminRevokeUserSessions = <ThrowOnError extends boolean = false>(
  options: Options<AdminRevokeUserSessionsData, ThrowOnError>,
): RequestResult<AdminRevokeUserSessionsResponses, AdminRevokeUserSessionsErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminRevokeUserSessionsResponses,
    AdminRevokeUserSessionsErrors,
    ThrowOnError
  >({ url: "/admin/users/{user_id}/revoke-sessions", ...options });

/**
 * Admin List Activity
 *
 * List activity across all users (admin only).
 *
 * Search, filtering, sorting, and pagination are all applied server-side by
 * the list_recent_activity RPC — the client sends params and renders results.
 * Repeat `action` and `user_id` for several; `from` and `to` (times with an
 * offset) bound the entries' time, both included, `to` after `from` and at most
 * 366 days later (422 otherwise). A sort by action follows `sort_order` when given:
 * the actions in the order their labels read in the dashboard's language (repeat
 * it), the actions it does not list after them by name.
 * A roadmap budget change names the month alone for a viewer who does not see
 * the budget (an admin). The RPC hides the figures before it searches
 * (`with_budget`), so a search cannot find an entry by them either.
 */
export const adminListActivity = <ThrowOnError extends boolean = false>(
  options?: Options<AdminListActivityData, ThrowOnError>,
): RequestResult<AdminListActivityResponses, AdminListActivityErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    AdminListActivityResponses,
    AdminListActivityErrors,
    ThrowOnError
  >({ url: "/admin/activity", ...options });

/**
 * Admin Activity Analytics
 *
 * Aggregated activity analytics for the admin dashboard (admin only).
 */
export const adminActivityAnalytics = <ThrowOnError extends boolean = false>(
  options?: Options<AdminActivityAnalyticsData, ThrowOnError>,
): RequestResult<AdminActivityAnalyticsResponses, AdminActivityAnalyticsErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    AdminActivityAnalyticsResponses,
    AdminActivityAnalyticsErrors,
    ThrowOnError
  >({ url: "/admin/activity/analytics", ...options });

/**
 * Admin Activity Actions
 *
 * Distinct activity actions across all time (admin only).
 *
 * Used to populate the activity filter dropdown so it matches the full,
 * unbounded table scope rather than the windowed analytics breakdown.
 */
export const adminActivityActions = <ThrowOnError extends boolean = false>(
  options?: Options<AdminActivityActionsData, ThrowOnError>,
): RequestResult<AdminActivityActionsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<AdminActivityActionsResponses, unknown, ThrowOnError>({
    url: "/admin/activity/actions",
    ...options,
  });

/**
 * Mcp Overview
 *
 * The MCP connector at a glance, for the home page and the Tools page (any signed-in
 * user).
 *
 * How it runs (off, Microsoft sign-in or a local test), the URL to add in Claude,
 * whether the Odoo tools are on, where the backend runs (Railway's environment inside
 * a Railway deployment, `local` anywhere else) and whether it may write to third-party
 * systems (`external_writes`), the groups of tools, and the tools the caller gets, by
 * their dashboard role read from their profile now, never the cookie's (from sign-in):
 * a developer every tool; an owner and an admin the catalogue (admin-only tools
 * included), the submissions and the tools for their role; a member only the
 * catalogue tools their teams and exceptions give them (read now), `whoami` and the
 * submissions. Each with its title, one-line summary, kind, group, access, whether a
 * developer paused it for everyone (`paused`), the caller's own switch
 * (`personal_enabled`) and whether it is served (`on`), then the tools that are coming
 * soon (never enabled or on; for a member those of the group parts they hold).
 *
 * By role: only a developer gets the switch for everyone itself (`enabled`,
 * `switchable`); the admin roles get who each tool is for (`audience`: one level from
 * the developers only to everyone, never a team's name); a member gets neither. The
 * teams' policy is read for a member's own list only. Odoo is never contacted: the
 * Odoo tools are on when the connector was built with them at startup (the gate,
 * `odoo/settings.py`), and writes follow the settings (`external_writes_enabled`). The
 * switches are read every time, also while Odoo is off, so a switch set beforehand
 * shows. When the switches for everyone cannot be read (within 5 s),
 * `tool_switches_known` is false for every role and no tool shows as paused, and when
 * the caller's own cannot, `personal_switches_known` is false and those show as on
 * (both logged); the MCP server enforces them itself, failing closed. A role that cannot be
 * read counts as a member's, and a member's policy that cannot be read gives `whoami`
 * and the submissions only (fail closed, logged). No secrets and no usage numbers:
 * those stay on the admin endpoints.
 */
export const getConnectorOverview = <ThrowOnError extends boolean = false>(
  options?: Options<GetConnectorOverviewData, ThrowOnError>,
): RequestResult<GetConnectorOverviewResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetConnectorOverviewResponses, unknown, ThrowOnError>({
    url: "/mcp/overview",
    ...options,
  });

/**
 * Get Tool Definition
 *
 * One tool exactly as DC Data lists it to Claude (any signed-in user).
 *
 * For a tool on the caller's own overview list (their role read now, a member's teams
 * and exceptions read now), not coming soon, and served by the running connector: its
 * description, input schema and hints verbatim, its parameters for people, and the
 * size of what Claude reads of it, its name, description and input schema (characters,
 * and tokens estimated as a quarter of them, as `make tool-sizes` counts). Built from
 * the tool object the MCP server serves, shaped as its tools/list shapes it
 * (`mcp.tool_definitions`), so it never drifts from what Claude reads. A tool switched
 * off for everyone or by the caller still answers: it is on their list. Every other name
 * is the same 404 `tool_not_found`, so a tool is never confirmed to someone who may not
 * see it.
 */
export const getToolDefinition = <ThrowOnError extends boolean = false>(
  options: Options<GetToolDefinitionData, ThrowOnError>,
): RequestResult<GetToolDefinitionResponses, GetToolDefinitionErrors, ThrowOnError> =>
  (options.client ?? client).get<GetToolDefinitionResponses, GetToolDefinitionErrors, ThrowOnError>(
    { url: "/mcp/tools/{name}/definition", ...options },
  );

/**
 * Set Personal Tool Enabled
 *
 * Switch one tool on or off for the caller alone, in Claude (any signed-in user).
 * Idempotent.
 *
 * For a tool the caller gets, as the overview lists it for them (their role read now,
 * a member's teams and exceptions read now), and not coming soon: anything else is a
 * 404 `tool_not_found`. `whoami` cannot be switched off (400 `tool_not_switchable`):
 * it is how a person checks their sign-in. DC Data then neither lists nor serves the
 * tool to them, under any email their Microsoft sign-in vouches for, from the next
 * call (this process at once, the others within about 30 s). Nobody else's tools
 * change, and no switch for everyone is touched. Returns the tool as the overview shows
 * it to the caller.
 */
export const setPersonalToolEnabled = <ThrowOnError extends boolean = false>(
  options: Options<SetPersonalToolEnabledData, ThrowOnError>,
): RequestResult<SetPersonalToolEnabledResponses, SetPersonalToolEnabledErrors, ThrowOnError> =>
  (options.client ?? client).put<
    SetPersonalToolEnabledResponses,
    SetPersonalToolEnabledErrors,
    ThrowOnError
  >({
    url: "/mcp/tools/{name}/personal",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Set Tool Enabled
 *
 * Switch one of the connector's tools on or off for everyone in Claude (developer
 * only, the role re-read on the call). Idempotent.
 *
 * The switch applies at once: a switched-off tool is left out of the tool list
 * and its calls are refused with a short message saying it is paused. An open Claude
 * session keeps the tool list it was given until its client lists tools again, but its
 * calls are refused all the same. `whoami` cannot be switched off (400
 * `tool_not_switchable`): it is how a person checks their sign-in. An unknown tool is a
 * 404 `tool_not_found`. Each real change is logged in the activity log with the tool's
 * name. Returns the tool as the overview shows it to the developer.
 */
export const adminSetToolEnabled = <ThrowOnError extends boolean = false>(
  options: Options<AdminSetToolEnabledData, ThrowOnError>,
): RequestResult<AdminSetToolEnabledResponses, AdminSetToolEnabledErrors, ThrowOnError> =>
  (options.client ?? client).put<
    AdminSetToolEnabledResponses,
    AdminSetToolEnabledErrors,
    ThrowOnError
  >({
    url: "/admin/mcp/tools/{name}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Mcp Usage
 *
 * Connector usage over the last `days` calendar days, Belgian time (admin only).
 *
 * One aggregate call: totals, calls per day split ok / error (every day of the
 * window, zeros included), per tool, per user and per error type.
 */
export const adminMcpUsage = <ThrowOnError extends boolean = false>(
  options?: Options<AdminMcpUsageData, ThrowOnError>,
): RequestResult<AdminMcpUsageResponses, AdminMcpUsageErrors, ThrowOnError> =>
  (options?.client ?? client).get<AdminMcpUsageResponses, AdminMcpUsageErrors, ThrowOnError>({
    url: "/admin/mcp/usage",
    ...options,
  });

/**
 * Admin Mcp Speed
 *
 * The connector's speed over the last `days` calendar days, Belgian time (admin only).
 *
 * One aggregate call (`mcp_speed_summary`): per day (every day of the window, zeros
 * included) the calls and Odoo calls, the three waits as shares of the Odoo calls'
 * time, the p95 wait, Odoo's p95 slowest request, the median duration and the
 * rate-limited calls; and per tool its calls, Odoo calls, median and p95 duration, p95
 * wait, p95 slowest request and rate-limited calls (`mcp/speed.py`). Figures only, no
 * thresholds: every failure is an issue (`GET /admin/mcp/issues`).
 */
export const adminMcpSpeed = <ThrowOnError extends boolean = false>(
  options?: Options<AdminMcpSpeedData, ThrowOnError>,
): RequestResult<AdminMcpSpeedResponses, AdminMcpSpeedErrors, ThrowOnError> =>
  (options?.client ?? client).get<AdminMcpSpeedResponses, AdminMcpSpeedErrors, ThrowOnError>({
    url: "/admin/mcp/speed",
    ...options,
  });

/**
 * Admin Mcp Calls
 *
 * The connector's tool calls, metadata only (admin only).
 *
 * Over `from` up to and including `to` (times with an offset), or else the last
 * `days` calendar days in Belgian time; `to` must come after `from`, at most 366
 * days later (422 otherwise). Repeat `tool` and `user_oid` (Entra object id) for
 * several; `outcome` is `ok` or `failed`; `issue_key` keeps an issue's failures.
 * Sorted by `sort_by` and `sort_dir` across pages, the id breaking ties (newest
 * first by default). A sort by tool or status follows `sort_order` when given: the
 * tools or error kinds (`ok` for a call that worked) in the order their labels read
 * in the dashboard's language (repeat it), the values it does not list after them by
 * their own value. Each call with its display name, its issue and its Odoo
 * figures. `total` counts every call matching the filters, also for a page past the
 * end.
 */
export const adminMcpCalls = <ThrowOnError extends boolean = false>(
  options?: Options<AdminMcpCallsData, ThrowOnError>,
): RequestResult<AdminMcpCallsResponses, AdminMcpCallsErrors, ThrowOnError> =>
  (options?.client ?? client).get<AdminMcpCallsResponses, AdminMcpCallsErrors, ThrowOnError>({
    url: "/admin/mcp/calls",
    ...options,
  });

/**
 * Admin Mcp Issues
 *
 * Every issue with a failure over the last `days` calendar days, Belgian time
 * (admin only).
 *
 * Each with its tool (null for a failure of the connector as a whole), kind,
 * category and status, its failures, people and tools in the window, its first and
 * last failure and its failures over every kept call (12 months), and its failures
 * per day of the window with the calls they are a share of. Latest failure first,
 * unpaged: the page sorts and filters them.
 */
export const adminMcpIssues = <ThrowOnError extends boolean = false>(
  options?: Options<AdminMcpIssuesData, ThrowOnError>,
): RequestResult<AdminMcpIssuesResponses, AdminMcpIssuesErrors, ThrowOnError> =>
  (options?.client ?? client).get<AdminMcpIssuesResponses, AdminMcpIssuesErrors, ThrowOnError>({
    url: "/admin/mcp/issues",
    ...options,
  });

/**
 * Admin Mcp Issues Attention
 *
 * The issues still to analyse, for the home page (admin only).
 *
 * Every issue with a failure over the last 90 calendar days whose status is new,
 * open, or regressed (resolved, then failed again), latest failure first, with its
 * failures over the last 7 calendar days; and how many issues with a failure in those
 * 90 days are acknowledged. 90 days is the longest period of the Statistieken page's
 * Fouten list, which the home page's links open, so the list holds what it counts.
 */
export const adminMcpIssuesAttention = <ThrowOnError extends boolean = false>(
  options?: Options<AdminMcpIssuesAttentionData, ThrowOnError>,
): RequestResult<AdminMcpIssuesAttentionResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<AdminMcpIssuesAttentionResponses, unknown, ThrowOnError>({
    url: "/admin/mcp/issues/attention",
    ...options,
  });

/**
 * Admin Mcp Issue
 *
 * One issue over the last `days` calendar days, by its URL-encoded key (admin only).
 *
 * As in the list, whenever it last failed, plus its history, newest first: the status
 * changes and the notes, each with its author. Its failed calls come from
 * `GET /admin/mcp/calls` with `issue_key`.
 */
export const adminMcpIssue = <ThrowOnError extends boolean = false>(
  options: Options<AdminMcpIssueData, ThrowOnError>,
): RequestResult<AdminMcpIssueResponses, AdminMcpIssueErrors, ThrowOnError> =>
  (options.client ?? client).get<AdminMcpIssueResponses, AdminMcpIssueErrors, ThrowOnError>({
    url: "/admin/mcp/issues/{key}",
    ...options,
  });

/**
 * Admin Mcp Issue Action
 *
 * Change an issue's status (developer only): acknowledge, resolve, ignore or reopen.
 *
 * Each sets the status, also when the issue already had it (so resolving a regressed
 * issue resolves it again from now), writes one entry to its history with the note,
 * if any, and the developer, and goes in the activity log. Answers the issue as it is
 * after, over the last `days` days. 404 `tool_issue_not_found` for a key no kept call
 * failed under; 422 for any other action (a note alone goes to
 * `POST /admin/mcp/issues/{key}/notes`) or a note over 2000 characters; 502 when
 * Supabase fails before the action is recorded. Once it is recorded the answer is a
 * 200, never an error that would have the page record it again: when the issue
 * cannot be read back, it is the issue as read before, with the status the action set.
 */
export const adminMcpIssueAction = <ThrowOnError extends boolean = false>(
  options: Options<AdminMcpIssueActionData, ThrowOnError>,
): RequestResult<AdminMcpIssueActionResponses, AdminMcpIssueActionErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminMcpIssueActionResponses,
    AdminMcpIssueActionErrors,
    ThrowOnError
  >({
    url: "/admin/mcp/issues/{key}/actions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Mcp Issue Note
 *
 * Add a note to an issue (admin only): a shared conversation about it.
 *
 * Writes one entry to its history with the note and the caller as author, and
 * changes no status: the activity log keeps no note. Answers the issue as it is
 * after, over the last `days` days. 404 `tool_issue_not_found` for a key no kept call
 * failed under; 422 for a note blank or over 2000 characters once trimmed; 502 when
 * Supabase fails before the note is recorded. Once it is recorded the answer is a 200,
 * as for a status change: when the issue cannot be read back, it is the issue as read
 * before.
 */
export const adminMcpIssueNote = <ThrowOnError extends boolean = false>(
  options: Options<AdminMcpIssueNoteData, ThrowOnError>,
): RequestResult<AdminMcpIssueNoteResponses, AdminMcpIssueNoteErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminMcpIssueNoteResponses,
    AdminMcpIssueNoteErrors,
    ThrowOnError
  >({
    url: "/admin/mcp/issues/{key}/notes",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Mcp Users
 *
 * Everyone seen by the connector (by Entra object id) plus everyone blocked (admin only).
 *
 * Each with their first and last call, their calls over the last 7 days and
 * their block, if any.
 */
export const adminMcpUsers = <ThrowOnError extends boolean = false>(
  options?: Options<AdminMcpUsersData, ThrowOnError>,
): RequestResult<AdminMcpUsersResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<AdminMcpUsersResponses, unknown, ThrowOnError>({
    url: "/admin/mcp/users",
    ...options,
  });

/**
 * Admin Mcp Unblock User
 *
 * Give a blocked person their connector access back (admin only). Idempotent.
 *
 * Takes effect within the MCP server's block-list cache time (about 30 s) for
 * calls; an open session's tool list comes back when its client lists tools
 * again. Unblocking someone who is not blocked changes and logs nothing. The
 * activity log's entry names the person as the block's does.
 */
export const adminMcpUnblockUser = <ThrowOnError extends boolean = false>(
  options: Options<AdminMcpUnblockUserData, ThrowOnError>,
): RequestResult<AdminMcpUnblockUserResponses, AdminMcpUnblockUserErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    AdminMcpUnblockUserResponses,
    AdminMcpUnblockUserErrors,
    ThrowOnError
  >({ url: "/admin/mcp/users/{user_oid}/block", ...options });

/**
 * Admin Mcp Block User
 *
 * Remove a person's connector access on Velta's side (admin only). Idempotent.
 *
 * The MCP server refuses their tool calls within its block-list cache time
 * (about 30 s). Their Microsoft account is managed by De Ceuster's IT provider
 * and stays as it is. Blocking someone already blocked keeps the original
 * block and logs nothing. The activity log's entry names the person by the email
 * the audit last saw for them (the oid when it saw none), as the entries of team
 * members and exceptions do: the activity log is kept 90 days, shorter than the
 * audit rows that hold the email.
 */
export const adminMcpBlockUser = <ThrowOnError extends boolean = false>(
  options: Options<AdminMcpBlockUserData, ThrowOnError>,
): RequestResult<AdminMcpBlockUserResponses, AdminMcpBlockUserErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminMcpBlockUserResponses,
    AdminMcpBlockUserErrors,
    ThrowOnError
  >({ url: "/admin/mcp/users/{user_oid}/block", ...options });

/**
 * Admin List Teams
 *
 * Every team, every exception and the colleagues they can name (admin only).
 *
 * `teams` holds the teams admins created, by name; the team of everyone in no team
 * is `default_team`, the Admins team `admins_team` (every dashboard admin by their
 * role and its extra members, with every access). `email_domains` are the domains a
 * member's email must have
 * (ALLOWED_EMAIL_DOMAIN), for the page to check as people type. `people` gathers
 * the team members, the people with exceptions, the De Ceuster accounts the
 * connector has seen (from its audit, while it lasts) and the dashboard accounts in
 * ALLOWED_EMAIL_DOMAIN, with their name (from their dashboard account, else the
 * one Microsoft gave the connector), their last connector call while they are
 * still recorded, and their Microsoft object id with its block, so the page blocks
 * and unblocks them (`/admin/mcp/users/{user_oid}/block`; no id for someone the
 * connector never saw). A block of an id that is none of these people's (an id seen
 * without an email, an email that is no colleague's, an older id of someone who now
 * calls with another) is a row of its own, so it can always be lifted here.
 */
export const adminListTeams = <ThrowOnError extends boolean = false>(
  options?: Options<AdminListTeamsData, ThrowOnError>,
): RequestResult<AdminListTeamsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<AdminListTeamsResponses, unknown, ThrowOnError>({
    url: "/admin/mcp/teams",
    ...options,
  });

/**
 * Admin Create Team
 *
 * Create a team with its group parts and apps, without members yet (admin only).
 *
 * A name of the Admins team in any language ("Beheerders", "Admins",
 * "Administrateurs", whatever its case) is taken (409 `team_name_taken`).
 */
export const adminCreateTeam = <ThrowOnError extends boolean = false>(
  options: Options<AdminCreateTeamData, ThrowOnError>,
): RequestResult<AdminCreateTeamResponses, AdminCreateTeamErrors, ThrowOnError> =>
  (options.client ?? client).post<AdminCreateTeamResponses, AdminCreateTeamErrors, ThrowOnError>({
    url: "/admin/mcp/teams",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Delete Team
 *
 * Delete a team with its members and grants (admin only).
 *
 * Its members fall back to their other teams, or to the default team when they
 * are in no other. The default team cannot be deleted (400 `team_not_deletable`),
 * nor can the Admins team (400 `admins_team_not_deletable`).
 */
export const adminDeleteTeam = <ThrowOnError extends boolean = false>(
  options: Options<AdminDeleteTeamData, ThrowOnError>,
): RequestResult<AdminDeleteTeamResponses, AdminDeleteTeamErrors, ThrowOnError> =>
  (options.client ?? client).delete<AdminDeleteTeamResponses, AdminDeleteTeamErrors, ThrowOnError>({
    url: "/admin/mcp/teams/{team_id}",
    ...options,
  });

/**
 * Admin Update Team
 *
 * Change a team's name, description, group parts or apps (admin only).
 *
 * A field left out stays as it is; `grants` is the full list. The default team
 * takes `grants` only (400 `team_not_editable`), and never an app (400
 * `app_not_for_default_team`). The Admins team takes nothing here (400
 * `admins_team_not_editable`): the dashboard names it and its access is everything;
 * its extra members change through the members route. One activity log entry naming
 * what changed, when something did.
 */
export const adminUpdateTeam = <ThrowOnError extends boolean = false>(
  options: Options<AdminUpdateTeamData, ThrowOnError>,
): RequestResult<AdminUpdateTeamResponses, AdminUpdateTeamErrors, ThrowOnError> =>
  (options.client ?? client).patch<AdminUpdateTeamResponses, AdminUpdateTeamErrors, ThrowOnError>({
    url: "/admin/mcp/teams/{team_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Set Team Members
 *
 * Set a team's members: the full list of De Ceuster emails (admin only).
 *
 * Emails are stored in lower case, each once. The default team has no members: an
 * empty list changes nothing, any member is a 400 `team_member_not_allowed`. On the
 * Admins team the list is its extra members: the dashboard admins are in it by their
 * role only, so a current admin in the list is left out and never stored (demoting
 * them then always takes them out). The activity log names who joined and who left.
 */
export const adminSetTeamMembers = <ThrowOnError extends boolean = false>(
  options: Options<AdminSetTeamMembersData, ThrowOnError>,
): RequestResult<AdminSetTeamMembersResponses, AdminSetTeamMembersErrors, ThrowOnError> =>
  (options.client ?? client).put<
    AdminSetTeamMembersResponses,
    AdminSetTeamMembersErrors,
    ThrowOnError
  >({
    url: "/admin/mcp/teams/{team_id}/members",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Set Person Overrides
 *
 * Set one person's exceptions: the full list; an empty list removes them (admin only).
 *
 * Each allows or denies a group part ("finance:read"), a single served tool
 * ("revenue_summary") or an app ("app:bezetting"), whatever the person's teams say;
 * a tool's exception wins over its group part's. An app opens only with every data
 * unit it requires too. Returns the person's stored exceptions, by unit. The
 * activity log names what was allowed, denied or removed.
 */
export const adminSetPersonOverrides = <ThrowOnError extends boolean = false>(
  options: Options<AdminSetPersonOverridesData, ThrowOnError>,
): RequestResult<AdminSetPersonOverridesResponses, AdminSetPersonOverridesErrors, ThrowOnError> =>
  (options.client ?? client).put<
    AdminSetPersonOverridesResponses,
    AdminSetPersonOverridesErrors,
    ThrowOnError
  >({
    url: "/admin/mcp/people/{email}/overrides",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
